import { Label } from 'office-ui-fabric-react/lib/Label';
import { useContext } from 'react';
import Context from '../context';
import { ActionTypes } from '../types/types';

import { Resources } from './resources';

interface RepetingActionsLoopsProps {
    hidden: boolean;
}

export const RepeatingActionsLoops = (props: RepetingActionsLoopsProps) => {
    const { state } = useContext(Context);

    return(
        <div className="repeating-actions-loops-section" hidden={props.hidden}>
            {state.repeatingActions.length > 0 
                ? <Label className="calc-repeating-actions-loop-repetition-label">{Resources.REPEATING_ACTION_LOOP_REPETITION_LABEL}</Label>
                : undefined
            }
            {state.repeatingActions.length > 0 
            ? state.repeatingActions.map(action => (
                <RepeatingAction actionName={action} /> ))
            : <div className="advanced-options-not-available">{Resources.NO_ADVANCED_OPTIONS_AVAILABLE}</div>
            }
        </div>
    );
}

interface RepetingActionProps {
    actionName: string;
}

export const RepeatingAction = (props: RepetingActionProps) => {
    const { state, dispatch } = useContext(Context);

    const changeRepeatingActionRepetitionValue = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const repeatingActionIteration: Record<string, number> = {};
        let iterationCount = e.target.valueAsNumber;

        if (iterationCount < 1) {
            iterationCount = 1;
        }
        repeatingActionIteration[props.actionName] = iterationCount;

        const action = {
            type: ActionTypes.UPDATE_REPEATING_ACTIONS_ITERATIONS,
            payload: repeatingActionIteration
        };
        dispatch(action);
    }

    return(
        <div className="calc-repeating-action" key={props.actionName}>
            <Label id={`${props.actionName}_repeatingaction`} className="calc-repeating-action-label">{props.actionName}</Label>
            <input
                aria-labelledby={`${props.actionName}_repeatingaction`}
                className="calc-repeating-action-input"
                type="number"
                value={state.repeatingActionsIterations[props.actionName]}
                onChange={changeRepeatingActionRepetitionValue}
            />  
        </div>      
    );
}